import Rest from '../Rest'

export default class PaymentSplitService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/payment_splits'

  static build(vs = null) {
    return new this(this.resource, null, vs)
  }
}
